import React from 'react'
import { useLocation, Link } from 'react-router-dom';
import UserMasterForm from "../../../components/Form/Master/UserMasterForm";
import { isViewOnly } from "../../../comman/permissions";

const USER_MASTER_SCREEN = '/user_master/list';

export default function EditUserMaster() {

    const location = useLocation();
    const detail = location.state;
    // The router already keeps somebody with only View off this path -- an /edit/ route asks for
    // Update -- so this is what holds if that ever stops being true. There is /user_master/view/:id
    // for reading, and the list sends them there.
    const readOnly = isViewOnly(USER_MASTER_SCREEN);

  return (
    <div className="p-4">
        <div className="flex justify-between items-center py-4 px-6">
            <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">Edit User</h1>
            <div className="flex items-center gap-4">
                {/* The sketch puts Screen Access here, beside the form's own header. */}
                {detail?.[0]?.id && !readOnly && (
                    <Link to={`/user_master/screen_access/${btoa(detail[0].id)}`}
                        className="text-sm font-semibold text-red-600 underline">
                        Screen Access
                    </Link>
                )}
                <Link to="/user_master/list">
                    <button className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Back</button>
                </Link>
            </div>
        </div>
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg px-4 py-2">
            <UserMasterForm detail={detail} page="user_master" readOnly={readOnly} />
        </div>
    </div>
  )
}
